import React from "react";

import Controls from "../controls/Controls";
import { HeaderIcon, WholeWrapper } from "./components";

const Header = ({ icon, title }) => {
  return (
    <WholeWrapper>
      {icon && <HeaderIcon>{icon}</HeaderIcon>}
      {title}
      <Controls />
    </WholeWrapper>
  );
};

export default Header;
